import { useTranslation } from 'react-i18next';

export default function Solution() {
  const { t } = useTranslation('common');

  return (
    <section className="py-24 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            {t('solution.title')}
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            {t('solution.subtitle')}
          </p>
        </div>

        <div className="relative mb-16">
          <img 
            src="https://public.readdy.ai/ai/img_res/a6d535687dbd6fbf23f4abc3e03b9761.jpg" 
            alt="Satellite Factory Connectivity" 
            className="w-full h-full object-cover object-center rounded-lg shadow-lg"
          />
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-slate-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-signal-tower-line text-3xl text-slate-700"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">{t('solution.monitoring.title')}</h3>
            <p className="text-gray-700">
              {t('solution.monitoring.description')}
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-slate-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-settings-3-line text-3xl text-slate-700"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">{t('solution.control.title')}</h3>
            <p className="text-gray-700">
              {t('solution.control.description')}
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-slate-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-vidicon-line text-3xl text-slate-700"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">{t('solution.communication.title')}</h3>
            <p className="text-gray-700">
              {t('solution.communication.description')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
